import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { SectorComercialGrupoViewDTO, SectorComercialGruposFilterDTO, SectorComercialViewDTO } from './types'

const getEndpoint = (url = '') => `sector-comercial${url}`

export const HttpSectorComercialABM = {
    getSectoresComerciales: (): Promise<SectorComercialViewDTO[]> => {
        return HttpAxiosRequest.get(getEndpoint())
    },

    getGrupos: (
        codSectorComercial: number,
        params?: SectorComercialGruposFilterDTO
    ): Promise<SectorComercialGrupoViewDTO[]> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(getEndpoint(`/${codSectorComercial}/grupos`), {
            ...params
        })
    },

    actualizarGrupos: (codSectorComercial: number, idsGrupos: number[]) => {
        return HttpAxiosRequest.post(getEndpoint(`/${codSectorComercial}/grupos`), idsGrupos)
    },

    update: (id: number, data: { nombreSectorComercial: string; codPais: number }): Promise<any> => {
        return HttpAxiosRequest.put(getEndpoint(`/${id}`), data)
    },

    deactivate: (id: number): Promise<any> => {
        return HttpAxiosRequest.delete(getEndpoint(`/${id}`))
    }
}
